export default class BConfig
{
	static getAccessToken()
	{
		return window._config.accessToken;
	}

	static getRoutes()
	{
		return window._config?.routes ?? {};
	}

	static getRoute(key)
	{
		const routes = this.getRoutes();

		return routes[key];
	}

	static getEnergyUnit()
	{
		return window._config?.units?.ENERGY ?? "kcal";
	}

	/**
	 * kJ → kcal factor from {@see \App\Classes\Calories::CONVERSION} via config.js.
	 */
	static getKjToKcalFactor()
	{
		const factor = window._config?.calories?.kjToKcal;
		if (factor == null || isNaN(Number(factor))) {
			throw new Error("Missing window._config.calories.kjToKcal (load /javascript/config.js)");
		}

		return Number(factor);
	}
}
